module.exports = __webpack_public_path__ + "img/binary.28e1b285.svg";